import { Pipe, PipeTransform } from '@angular/core';

import { NgSelectModel } from '../../shared/models/ng-select.model';
import { MapToNgSelectListPipe } from './map-to-ng-select-list.pipe';

@Pipe({
    name: 'mapAllowedRatedCurrentToSelectList',
    standalone: false
})
export class MapAllowedRatedCurrentToSelectListPipe implements PipeTransform {

  transform(values: string[], allowedRatedCurrents: string[]): NgSelectModel[] {
    if (allowedRatedCurrents?.length) {
      return allowedRatedCurrents.map(ratedCurrent => {
        return {
          value: ratedCurrent,
          disabled: false
        }
      });
    }

    return new MapToNgSelectListPipe().transform(values);
  }

}
